import axios from "axios";

const state = {
	categories: [],
	editingCategory: {}
};

const actions = {
    async loadCategories(context){
        return axios.get("/api/1/categories").then(function(response){

			context.commit("setCategories",response.data);
        });
	},
	async loadCategory(context,name){
		return axios.get("/api/1/category/info",{params:{name:name}}).then(function(response){
			
			context.commit("setEditingCategory",response.data);
		})
	}
}

const mutations = {
	setCategories(state,data){
		state.categories=data;
	},
	setEditingCategory(state,data){
		for(var i=0; i<data.users.length; i++){
			if(!data.users[i].uact){
				data.users[i].uact = "";
			}
			if(!data.users[i].uprm){
				data.users[i].uprm = "";
			}
		}
		state.editingCategory = data;
	}
}

const getters = {
	categories(state){
		return state.categories;
	},
	editingCategory(state){
		return state.editingCategory;
	}
};
  

export default {
    state,
    actions,
    mutations,
    getters
};